// Navbar.js — Top navigation bar for authenticated pages
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const student  = JSON.parse(localStorage.getItem('student')) || {};

  const handleLogout = () => {
    localStorage.removeItem('student');
    navigate('/login');
  };

  const links = [
    { path: '/dashboard',    label: '🏠 Dashboard' },
    { path: '/companies',    label: '🏢 Companies'  },
    { path: '/applications', label: '📄 Applications' },
  ];

  return (
    <nav className="navbar">
      <div className="container navbar-inner">
        {/* Brand */}
        <span className="navbar-brand" onClick={() => navigate('/dashboard')} style={{ cursor: 'pointer' }}>
          Placement<span>Portal</span>
        </span>

        {/* Nav links */}
        <div className="navbar-links">
          {links.map(l => (
            <span
              key={l.path}
              className={`nav-link ${location.pathname === l.path ? 'active' : ''}`}
              onClick={() => navigate(l.path)}
            >
              {l.label}
            </span>
          ))}

          {/* User chip + logout */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginLeft: '0.75rem' }}>
            <span style={{
              background: 'var(--gradient)',
              borderRadius: '50%',
              width: 30, height: 30,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontWeight: 700, fontSize: '0.8rem',
              flexShrink: 0,
            }}>
              {(student.name || 'U')[0].toUpperCase()}
            </span>
            <span style={{ fontSize: '0.85rem', color: 'var(--text-muted)', maxWidth: 100, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {student.name}
            </span>
            <button className="btn btn-sm btn-outline" onClick={handleLogout} style={{ marginLeft: '0.25rem' }}>
              Logout
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
